export enum EditStatus {
    New,
    EditDisabled,
    EditEnabled
}
